import React, { Fragment, useEffect } from 'react';
import { MenuItem, Select, Autocomplete, TextField, Typography, InputLabel, FormControl } from '@mui/material';
import FilterAccordian from '../filterAccordian';
import Breadcrumb from '../common/breadcrumb';
import { userRequest } from '../../auth/requestMethods';
import { Users } from 'react-feather';
import CustomTable from '../tables/MuiDataGrid';

const Manage = ({ history }) => {
  useEffect(() => {
    document.title = 'PFSA | Users | Manage';
  }, []);
  const [perPage, setPerPage] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [filters, setFilters] = React.useState({ roles: [], is_active: 'All' });
  const [appliedFilters, setAppliedFilters] = React.useState(['is_active']);
  const [dataIsFetching, setDataIsFetching] = React.useState(true);
  const [tableData, setTableData] = React.useState({
    count: 0,
    users: [],
  });

  React.useEffect(() => {
    setDataIsFetching(true);

    let foundFilter = [];
    let statusFilterValue = filters.is_active;

    if (statusFilterValue === 'ACTIVE') {
      statusFilterValue = true;
    } else if (statusFilterValue === 'INACTIVE') {
      statusFilterValue = false;
    } else {
      statusFilterValue = '';
    }

    let queryString = Object.entries(filters)
      .map(([key, value]) => {
        if (typeof value === 'boolean' || value.length > 0) {
          if (key === 'is_active') {
            return '';
          }
          foundFilter.push(key);
          return encodeURIComponent(key) + '=' + encodeURIComponent(value);
        }
        return '';
      })
      .filter((Q) => !!Q)
      .join('&');

    if (statusFilterValue !== '') {
      foundFilter.push('is_active');
      queryString += `&is_active=${statusFilterValue}`;
    }

    setAppliedFilters(foundFilter);

    userRequest()
      .get(`/users?per_page=${perPage}&page=${page}&${queryString}`)
      .then(({ data }) => {
        console.log(data);
        setTableData({
          count: data.total,
          users: data.users,
        });
        setDataIsFetching(false);
      })
      .catch(({ response }) => {
        console.log(response);
        setDataIsFetching(false);
      });
  }, [filters, perPage, page]);

  function setStatus(id, data) {
    userRequest()
      .post(`/users/update/${id}`, data)
      .then(() => {
        let users = [];
        if (meetFilterConditions(data)) {
          users = tableData.users.map((user) => {
            if (id === user.id) user.is_active = !user.is_active;
            return user;
          });
        } else {
          users = tableData.users.filter((user) => user.id !== id);
        }
        setTableData({
          count: users.length,
          users,
        });
      })
      .catch(() => {});
  }

  function getFilters() {
    return Object.entries(filters)
      .map(([key, value]) => {
        if (value !== '') {
          if (key === 'roles' && value?.length) {
            return `role:${value?.length}`;
          } else if (key === 'is_active') {
            if (value === 'ACTIVE') {
              return `Status: Active`;
            }
            if (value === 'INACTIVE') {
              return `Status: Inactive`;
            }
            if (value === 'All') {
              return [];
            }
          }
        }
      })
      .filter((x) => x !== undefined && x.length !== 0);
  }

  function meetFilterConditions(data) {
    if (appliedFilters.length > 0) {
      if (filters.is_active === 'ACTIVE') {
        return data.is_active;
      } else if (filters.is_active === 'INACTIVE') {
        return !data.is_active;
      }
      return true;
    }
    return true;
  }

  const actionMethods = {
    toggleEdit: (row) => {
      history.push(`${process.env.PUBLIC_URL}/users/edit/${row.id}`, {
        state: { action: 'update' },
      });
    },
    toggleActive: (row) => setStatus(row.id, { is_active: !row.is_active }),
  };
  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'surname',
      headerName: 'Surname',
      flex: 1,
    },
    {
      field: 'email',
      description: 'This email is used to login as well',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'role',
      headerName: 'User Role',
      flex: 1,
    },
    {
      field: 'created_at',
      headerName: 'Date Created',
      width: 110,
    },
    {
      field: 'activated_date_time',
      headerName: 'Date Activated',
      width: 110,
    },
    {
      field: 'is_active',
      headerName: 'Status',
      headerAlign: 'center',
      width: 110,
      renderCell: ({ row }) =>
        row.is_active ? (
          <Typography className="font-success mx-auto">Active</Typography>
        ) : (
          <Typography className="font-danger mx-auto">Inactive</Typography>
        ),
    },
  ];

  return (
    <Fragment>
      <Breadcrumb icon={<Users />} title="Manage" parent="User" />

      <div className="container-fluid">
        <FilterAccordian filters={getFilters()}>
          <form className="theme-form">
            <div className="form-group row">
              <Autocomplete
                multiple
                // options={['VIEWER', 'APPLICATOR','ADMINISTRATOR','SUPERUSER']}
                options={['Viewer', 'Applicator', 'Administrator', 'Superuser']}
                onChange={(e, val) => setFilters({ ...filters, roles: val })}
                getOptionLabel={(option) => option}
                renderInput={(params) => <TextField {...params} label="Role" />}
              />
            </div>
            <div className="form-group row">
              <div className="form-group row mx-0">
                <FormControl>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={filters.is_active}
                    name="propertyType"
                    label="Status"
                    onChange={(e) => setFilters({ ...filters, is_active: e.target.value })}
                    style={{
                      fontStyle: filters.is_active === 'All' ? 'italic' : 'normal',
                    }}
                  >
                    <MenuItem value={'All'} style={{ fontStyle: 'italic' }}>
                      All
                    </MenuItem>
                    <MenuItem value={'ACTIVE'}>Active</MenuItem>
                    <MenuItem value={'INACTIVE'}>Inactive</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </form>
        </FilterAccordian>
      </div>
      <button
        onClick={() => history.push(`${process.env.PUBLIC_URL}/users/create`)}
        className="btn btn-secondary m-15"
        type="submit"
      >
        <i className="fa fa-plus fa-xl" aria-hidden="true"></i>
      </button>
      <div className="container-fluid">
        <CustomTable
          rows={tableData.users}
          actions={actionMethods}
          columns={columns}
          setPageSize={setPerPage}
          setPage={setPage}
          rowCount={tableData.count}
          pageSize={perPage}
          loading={dataIsFetching}
        />
      </div>
    </Fragment>
  );
};

export default Manage;
